import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SessionService } from './../../auth/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  url: string = environment.deviceHealthSyslogs;

  constructor(
    private httpClient: HttpClient,
    private sessionService: SessionService,
  ) {}

  async pingBackend(): Promise<boolean> {
    try {
      const result = await this.httpClient
        .get(`${this.url}/monitor/ping`, {
          responseType: 'text',
        })
        .toPromise();

      return result === 'pong';
    } catch (ex: any) {
      return false;
    }
  }

  async getRequests(count: number, paginationToken): Promise<SyslogResponse> {
    const requests = await this.httpClient
      .get<SyslogResponse>(
        `${this.url}/syslogs?count=${count}&type=dcc&paginationToken=${paginationToken}`,
      )
      .toPromise();

    return requests;
  }

  submitNewRequest(newRequest: CreateSyslogRequest): Promise<void> {
    return this.httpClient
      .post<void>(`${this.url}/syslogs`, newRequest, {
        headers: {
          Authorization: this.getIdToken(),
        },
      })
      .toPromise();
  }

  private getIdToken() {
    const token = this.sessionService.getCurrentSession()!.token;
    return `Bearer ${token}`;
  }
}
export interface SyslogResponse {
  syslogRecords: SyslogRequest[];
  paginationToken: string;
  endOfSet: boolean;
}

export interface SyslogRequest {
  fileId: string;
  requestId: string;
  serialNumber: string;
  status: string;
  requestedDate: string;
  requestedBy: string;
  name: string;
  description: string;
  url: string;
}

export interface CreateSyslogRequest {
  serialNumbers: string[];
  name: string;
  description: string;
  type: string;
}
